<div *ngIf="content && content.length > 5 && localService.languageContent && localService.languageContent.paging">
  <div *ngIf="isPopUp && !isIframe">
    <app-popup-header></app-popup-header>
    <div class="modal-body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}" style="overflow-x: auto;">
      <div class="row">
        <div class="col-12">
          <div *ngIf="content != ''" [innerHTML]="sanitizedHtml"
            [ngClass]="localService.getLanguageCode(contentLanguageId)">
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!isPopUp && !isIframe && content != ''" [innerHTML]="sanitizedHtml"
    [ngClass]="localService.getLanguageCode(contentLanguageId)">
  </div>
  <div *ngIf="isIframe && isPopUp" class="overlay">
    &nbsp;
  </div>
  <div *ngIf="isIframe" [ngClass]="isPopUp ? 'iframe_popup' : ''">
    <div style="text-align: center;">
      <button class="button_icon button_icon_color"
        style="transform: rotate(45deg);font-size: 30px !important;  color: red !important;"
        title="{{localService.languageContent.common.close}}" (click)="onClosePopup()">add_circle_outline</button>
      <button class="button_icon button_icon_color" style="font-size: 30px !important;"
        title="{{localService.languageContent.common.print}}" (click)="onPrint()">print</button>

      <button type="button" class="btn btn-primary" style="margin-left: 25px;"
        (click)="onAction(isRunningOneByOne ? 6: 5,true)"
        *ngIf="isSinglePrint && printHtml && printHtml.values && printHtml.values.length > 1">
        &nbsp;{{isRunningOneByOne ? localService.languageContent.paging.stop_one_by_one
        : localService.languageContent.paging.print_one_by_one}}
        <span class="en" style="margin-left: 10px;">&nbsp;{{currentSinglePrintIndex +
          1}}&nbsp;/&nbsp;{{printHtml.values.length}}&nbsp;</span>
      </button>

      <div *ngIf="!isRunningOneByOne && isSinglePrint && printHtml && printHtml.values && printHtml.values.length > 1">
        <button type="button" class="btn btn-primary" style="margin-left: 25px;" (click)="onAction(7)"
          [disabled]="currentSinglePrintIndex == 0">&nbsp;{{localService.languageContent.paging.go_first}}</button>
        <button type="button" class="btn btn-primary" style="margin-left: 25px;" (click)="onAction(1)"
          [disabled]="currentSinglePrintIndex == 0">&nbsp;{{localService.languageContent.paging.print_prev}}</button>
        <button type="button" class="btn btn-primary" style="margin-left: 25px;" (click)="onAction(2)"
          [disabled]="currentSinglePrintIndex == 0">&nbsp;{{localService.languageContent.paging.show_prev}}</button>
        <span class="en" style="margin-left: 25px;">&nbsp;{{currentSinglePrintIndex +
          1}}&nbsp;/&nbsp;{{printHtml.values.length}}&nbsp;</span>
        <button type="button" class="btn btn-primary" style="margin-left: 25px;" (click)="onAction(3)"
          [disabled]="currentSinglePrintIndex == printHtml.values.length - 1">&nbsp;{{localService.languageContent.paging.show_next}}</button>
        <button type="button" class="btn btn-primary" style="margin-left: 25px;" (click)="onAction(4)"
          [disabled]="currentSinglePrintIndex == printHtml.values.length - 1">&nbsp;{{localService.languageContent.paging.print_next}}</button>
      </div>
    </div>
    <iframe id="{{elementIds.iframe}}" style="height: 100%;width: 100%;margin-top: 20px;"></iframe>
  </div>
</div>
<app-print *ngIf="isPrint" [isQrCodePrint]="true" [content]="printContent" (onPrinted)="onPrinted()" />